import { render, staticRenderFns } from "./ConfigColorPicker.vue?vue&type=template&id=cc578a6c"
import script from "./ConfigColorPicker.vue?vue&type=script&lang=js"
export * from "./ConfigColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports